import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import SectionHead from './SectionHead';
import { EASE, Reveal } from './reveal';
import ShippingEstimator from './ShippingEstimator';

// HQ label coordinates are anchored to /app/frontend/public/assets/us_map_neon.webp
// The star pin baked into the image sits at ~(73.3%, 81.4%) of the asset.
const HQ_LEFT = '73.3%';
const HQ_TOP = '81.4%';

export default function ServiceArea() {
  return (
    <section id="coverage" className="relative py-16 sm:py-20 lg:py-32 bg-black overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        <SectionHead
          eyebrow="Delivery Options"
          titleLines={['We Deliver', <span key="accent" className="text-cyan-300">to the Lower 48</span>]}
        />

        <Reveal delay={0.2}>
          <div
            className="relative mt-12 sm:mt-16 lg:mt-20 flex justify-center"
            data-testid="coverage-map-wrapper"
          >
            <div className="relative w-full max-w-[1050px]">
              <motion.img
                src="/assets/us_map_neon.webp"
                alt="Lower 48 delivery coverage map"
                className="relative w-full h-auto object-contain select-none pointer-events-none"
                style={{ mixBlendMode: 'screen' }}
                data-testid="coverage-map-image"
                initial={{ opacity: 0, scale: 0.985 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.35 }}
                transition={{ duration: 1.0, ease: EASE }}
              />

              {/* HQ callout */}
              <div
                className="absolute pointer-events-none"
                style={{ left: HQ_LEFT, top: HQ_TOP }}
                data-testid="coverage-hq-pin"
              >
                <div className="hidden sm:flex absolute right-0 top-0 items-center -translate-y-1/2 flex-row-reverse">
                  <motion.span
                    className="block mr-3 h-px bg-cyan-300/70 origin-right"
                    initial={{ width: 0, opacity: 0 }}
                    whileInView={{ width: 56, opacity: 1 }}
                    viewport={{ once: true, amount: 0.35 }}
                    transition={{ duration: 0.7, ease: EASE, delay: 0.9 }}
                  />
                  <motion.span
                    className="font-tech text-[9px] sm:text-[10px] tracking-[0.24em] uppercase text-cyan-200 whitespace-nowrap px-2 py-1 rounded-sm bg-black/70 border border-cyan-400/40"
                    initial={{ opacity: 0, x: 8 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.35 }}
                    transition={{ duration: 0.7, ease: EASE, delay: 1.3 }}
                    data-testid="coverage-hq-label"
                  >
                    HQ &middot; Fort Myers, FL
                  </motion.span>
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        <ShippingEstimator />
      </div>
    </section>
  );
}
